import { QueryParams } from '../api/api.service';

export const apiUrlKey = 'API_URL';

export const buildResource = (params?: QueryParams, ...pathValues: string[]): string => {
  const path = pathValues.join('/');
  const query = !isNil(params) ? `?${queryParams(params)}` : '';
  return `${path}${query}`;
};

const queryParams = (params: QueryParams): string =>
  Object.keys(params)
    .reduce((prevParams: string[], key) => {
      if (isNil(params[key])) {
        return prevParams;
      }

      if (Array.isArray(params[key])) {
        return [...prevParams, params[key].map((value: string) => `${key}=${value}`).join('&')];
      }

      return [...prevParams, `${key}=${params[key]}`];
    }, [])
    .join('&');

/* eslint-disable @typescript-eslint/no-explicit-any */
function isNil(value: any): value is null | undefined {
  return value == null;
}
